import { takeLatest, all, call, put } from "redux-saga/effects";
import { Auth } from "aws-amplify";

import showErrorMessage from "../../utils/showErrorMessage";

import { signInSuccess, signInFailure, signOutSuccess } from "./user.actions";

import {
  SIGN_IN_START,
  CHECKING_AUTH_START,
  SIGN_OUT_START,
} from "./user.types";

export function* signIn({ payload: { username, password } }) {
  try {
    const signInResult = yield Auth.signIn(username, password);

    yield put(signInSuccess(signInResult));
  } catch (errors) {
    yield showErrorMessage([{
      message: errors.name,
      stack: errors.message,
    }]);
    yield put(signInFailure(errors));
  }
}

export function* checkAuth() {
  try {
    const signInResult = yield Auth.currentAuthenticatedUser();

    yield put(signInSuccess(signInResult));
  } catch ({ errors }) {
    yield showErrorMessage(errors);
    yield put(signInFailure(errors));
  }
}

export function* signOut() {
  try {
    yield Auth.signOut();

    yield put(signOutSuccess());
  } catch ({ errors }) {
    yield showErrorMessage(errors);
  }
}

export function* onCheckingAuthStart() {
  yield takeLatest(CHECKING_AUTH_START, checkAuth);
}

export function* onSignInStart() {
  yield takeLatest(SIGN_IN_START, signIn);
}

export function* onSignOutStart() {
  yield takeLatest(SIGN_OUT_START, signOut);
}

export function* userSagas() {
  yield all([
    call(onCheckingAuthStart),
    call(onSignInStart),
    call(onSignOutStart),
  ]);
}
